import { CustomerCompanyMessage } from './CustomerCompanyMessage';
import { Iso8601DateTimeString } from './Iso8601DateTimeString';

export const WebhookResourceTypes = {
    DRAFT_ENQUIRY: 'DRAFT_ENQUIRY',
    ENQUIRY: 'ENQUIRY',
    APPROVAL_REQUEST: 'APPROVAL_REQUEST',
    OFFER: 'OFFER',
} as const;

export type ResourceType = (typeof WebhookResourceTypes)[keyof typeof WebhookResourceTypes];

export interface WebhookGatewayMessage {
    id: string;
    secret: string;
    name: string;
    customerIds: string[];
    customers: CustomerCompanyMessage[];
    url: string;
    resourceTypes: ResourceType[];
    enabled: boolean;
    createdDate: Iso8601DateTimeString;
    lastModifiedDate: Iso8601DateTimeString;
}

export interface WebhookRequestMessage {
    name: string;
    url: string;
    groupId: string;
    customerIds: string[];
    resourceTypes: ResourceType[];
    enabled: boolean;
}

export interface WebhookMessage {
    id: string;
    secret: string;
    name: string;
    groupId: string;
    customerIds: string[];
    url: string;
    resourceTypes: ResourceType[];
    enabled: boolean;
    createdDate: Iso8601DateTimeString;
    lastModifiedDate: Iso8601DateTimeString;
}
